import { RiEyeLine, RiEyeOffLine } from '@/shared/icons/remix'

/** Open eye when plain text is visible; crossed eye when masked (dots). */
export function PasswordVisibilityIcon({
  visible,
  size,
}: Readonly<{ visible: boolean; size: number }>) {
  return visible ? (
    <RiEyeLine size={size} aria-hidden />
  ) : (
    <RiEyeOffLine size={size} aria-hidden />
  )
}
